var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabSettingsPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#36F6FF",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.084C11 19.8452 11 18.7249 11.6959 18.0299C12.391 17.334 13.5112 17.334 15.75 17.334H22.0833C24.3222 17.334 25.4424 17.334 26.1375 18.0299C26.8333 18.7249 26.8333 19.8452 26.8333 22.084C26.8333 24.3228 26.8333 25.443 26.1375 26.1381C25.4424 26.834 24.3222 26.834 22.0833 26.834H15.75C13.5112 26.834 12.391 26.834 11.6959 26.1381C11 25.443 11 24.3228 11 22.084Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.3333V15.75C14.1667 14.4902 14.6672 13.282 15.558 12.3912C16.4488 11.5004 17.657 11 18.9167 11C20.1765 11 21.3847 11.5004 22.2755 12.3912C23.1663 13.282 23.6667 14.4902 23.6667 15.75V17.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabSettingsPasswordIcon);
export default __webpack_public_path__ + "static/media/tc_cab_settings_password_icon.4fc8a625f3dc31b7ce3c8ca5d5ba9637.svg";
export { ForwardRef as ReactComponent };